// Runtime config for the ported design system.
//
// The prototype components (ui.tsx, interactions.tsx) read a handful of
// config values off `window.*` — that's the model the design bundle shipped
// with. Rather than rewrite every reference, we keep the bag and populate it
// here, once, as a side-effect import. Values mirror the design bundle's
// data.jsx so the components behave identically to the mockups.

declare global {
  interface Window {
    __lang?: string
    WORK_HOURS?: typeof WORK_HOURS
    STAGES?: typeof STAGES
    AGENT_LABEL?: typeof AGENT_LABEL
    MANAGERS?: typeof MANAGERS
    USD_RATE?: number
    FUNNELS?: unknown[]
  }
}

// Asia/Tashkent working day (Worldunicorns): 10:00–17:00, lunch 13:00–13:30.
export const WORK_HOURS = {
  start: '10:00',
  end: '17:00',
  lunchStart: '13:00',
  lunchEnd: '13:30',
  days: 'Пн–Сб',
  tz: 'Asia/Tashkent',
}

// Bitrix pipeline stage labels (MUROJAT funnel) — used by StageChip.
export const STAGES = {
  NEW: { id: 'NEW', label: 'MUROJAT', descKey: 'stage.NEW' },
  UC_2RLFLC: { id: 'UC_2RLFLC', label: 'COMMENTLA', descKey: 'stage.UC_2RLFLC' },
  UC_T4SS6O: { id: 'UC_T4SS6O', label: 'MALUMOT SORALDI', descKey: 'stage.UC_T4SS6O' },
  UC_FNNTOD: { id: 'UC_FNNTOD', label: 'POVTOR YOZDIK', descKey: 'stage.UC_FNNTOD' },
  UC_6FWG45: { id: 'UC_6FWG45', label: 'TEL QOLDIRDI', descKey: 'stage.UC_6FWG45' },
  UC_FWNCDJ: { id: 'UC_FWNCDJ', label: 'TEL KOTARMADI', descKey: 'stage.UC_FWNCDJ' },
  UC_L2JM6T: { id: 'UC_L2JM6T', label: 'ESLATMA', descKey: 'stage.UC_L2JM6T' },
  UC_EYC73M: { id: 'UC_EYC73M', label: 'TG-MALUMOT', descKey: 'stage.UC_EYC73M', star: true },
}

// Task-creator agent display labels — used by AgentBadge / AIInline.
export const AGENT_LABEL = {
  telegram_analyst: 'TelegramAnalyst',
  call_analyst: 'CallAnalyst',
  watcher: 'WatcherAgent',
  reactivation: 'ReactivationAgent',
  task_manager: 'TaskManager',
}

// Real Bitrix users — used by mgrName().
export const MANAGERS = {
  928: { bitrixId: 928, name: 'Нафиса Собирова', short: 'Нафиса С.', tg: '@Nafis_manager01', tgLink: 'https://t.me/Nafis_manager01' },
  1026: { bitrixId: 1026, name: 'Toxir T', short: 'Toxir T', tg: '@toxir_wu', tgLink: 'https://t.me/toxir_wu' },
}

export const USD_RATE = 12600 // 1 USD ≈ 12 600 UZS (demo rate)

if (typeof window !== 'undefined') {
  window.__lang = window.__lang || 'ru'
  window.WORK_HOURS = WORK_HOURS
  window.STAGES = STAGES
  window.AGENT_LABEL = AGENT_LABEL
  window.MANAGERS = MANAGERS
  window.USD_RATE = USD_RATE
}
